import '@fontsource/archivo/300.css'
import '@fontsource/archivo/400.css'
import '@fontsource/archivo/500.css'
import '@fontsource/archivo/700.css'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { FC } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

import theme from '~/app/providers/ui/theme'

const withUI = (Component: FC) => {
  return function WrappingComponent() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer />
        <Component />
      </ThemeProvider>
    )
  }
}

export default withUI
